import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    container: {
      marginTop: token.marginSM,
      width: '100% !important'
    },

    titleContainer: {
      maxWidth: 440,
      width: '100%'
    },

    description: {
      maxWidth: 320
    },

    socialSetupInstructions: {
      padding: token.paddingSM,
      borderRadius: token.borderRadiusLG,
      border: `1px solid ${token.colorBorderSecondary}`,
      background: token.colorFillAlter
    },

    callbackUrlText: {
      display: 'block',
      width: '100%',
      wordBreak: 'break-all'
    },

    card: {},
    authInnerCard: {
      border: `1px solid ${token.colorBorderSecondary}`
    },
    authMethodsPanel: {
      width: '100%'
    },

    authMethodRow: {
      display: 'grid',
      gridTemplateColumns: 'minmax(140px, 1fr) auto auto auto',
      alignItems: 'center',
      gap: token.marginSM,
      '@media (max-width: 900px)': {
        gridTemplateColumns: '1fr',
        alignItems: 'flex-start'
      }
    },
    authMethodActionCol: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      '& .ant-btn': {
        minWidth: 96,
        paddingInline: token.paddingSM
      }
    },
    statusTag: {
      marginInlineEnd: 0,
      fontSize: token.fontSize,
      lineHeight: '22px'
    },
    authMethodName: {
      fontSize: token.fontSizeLG,
      lineHeight: '24px'
    }
  }
})
